import { t } from 'services/i18n'

export const COMPARISON_TYPES = {
  previousPeriod: 'previousPeriod',
  previousYear: 'previousYear',
  previousPeriods: 'previousPeriods'
}

export const DATE_RANGES = {
  allTime: 'allTime',
  today: 'today',
  yesterday: 'yesterday',

  thisWeek: 'thisWeek',
  lastWeek: 'lastWeek',

  last7Days: 'last7Days',
  last14Days: 'last14Days',
  last30Days: 'last30Days',
  last90Days: 'last90Days',

  thisMonth: 'thisMonth',
  lastMonth: 'lastMonth',

  last12Months: 'last12Months',

  thisYear: 'thisYear',
  lastYear: 'lastYear',

  thisQuarter: 'thisQuarter',
  lastQuarter: 'lastQuarter'
}

export const INTERVAL_OPTIONS = [
  {
    value: 'day',
    content: t('common:TimeIntervalSelector.daily', 'D')
  },
  {
    value: 'week',
    content: t('common:TimeIntervalSelector.weekly', 'W')
  },
  {
    value: 'month',
    content: t('common:TimeIntervalSelector.monthly', 'M')
  }
]

export const DATE_RANGE_OPTIONS = [
  {
    days: 90,
    value: '3_months',
    content: t('generic:DateRangeOptions.3m', '3M')
  },
  {
    days: 180,
    value: '6_months',
    content: t('generic:DateRangeOptions.6m', '6M')
  },
  {
    days: 365,
    value: '12_months',
    content: t('generic:DateRangeOptions.12m', '12M')
  },
  {
    days: 730,
    value: '2_years',
    content: t('generic:DateRangeOptions.2y', '2Y')
  }
]
